import { gql } from 'Utils/apolloClient'
import InstallmentDataFragment from '../Queries/installmentDataFragment'

const installmentPaymentMutation = gql`
  mutation InstallmentPayment($paymentExternal: PaymentExternalAttributes, $installmentId: ID!,
                              $paymentIntentId: ID, $paymentMethod: PaymentMethodAttributes,
                              $useCardOnFile: Boolean, $paymentSource: String!, $saveCardOnFile: Boolean) {
    installmentPayment(input: { paymentExternal: $paymentExternal, invoiceId: $installmentId,
                                paymentIntentId: $paymentIntentId, paymentMethod: $paymentMethod,
                                useCardOnFile: $useCardOnFile, paymentSource: $paymentSource,
                                saveCardOnFile: $saveCardOnFile }) {
      invoice {
        ...installmentData
      }
    }
  }

  ${InstallmentDataFragment}`

export default installmentPaymentMutation
